import { FC } from 'react';
import { classes } from './Navigation.st.css';
import { AccountButton } from '../AccountButton';
import { Link } from 'react-router-dom';
import { useAppSelector } from 'src/hooks';
import { selectSite } from 'src/features/site-slice';
import { EVENTS_ROOT } from 'src/redesign/shared/routes';
import {
  hasRequestEventCreationRoleSelector,
  isAdminOrOwnerSelector,
  isEventManagerSelector,
  isEventHostManagerSelector,
} from 'src/redesign/features/Account/store/selectors';
import { eventsSelector } from 'src/redesign/features/Events/store/selectors';

export const Navigation: FC = () => {
  const hasRequestEventCreationRole = useAppSelector(hasRequestEventCreationRoleSelector);
  const isAdminOrOwner = useAppSelector(isAdminOrOwnerSelector);
  const isEventManager = useAppSelector(isEventManagerSelector);
  const isEventHostManager = useAppSelector(isEventHostManagerSelector);
  const events = useAppSelector(eventsSelector);

  // Determine if billing link should be visible
  const shouldShowBilling =
    (!hasRequestEventCreationRole && !isEventManager && !isEventHostManager) || isAdminOrOwner;

  // Check if any events have hostAccount to show payouts
  const shouldShowPayouts = events && events.some((event) => event.hostAccount);

  return (
    <nav className={classes.navigation}>
      <a
        href="https://ticketspotapp.com/docs"
        className={`${classes.navigationLink} ${classes.hideOnMobile}`}
      >
        Help
      </a>
      {shouldShowBilling && (
        <Link
          to={`${EVENTS_ROOT}/billing`}
          className={`${classes.navigationLink} ${classes.hideOnMobile}`}
        >
          Billing
        </Link>
      )}
      {shouldShowPayouts && (
        <Link
          to={
            hasRequestEventCreationRole ? `${EVENTS_ROOT}/host-payouts` : `${EVENTS_ROOT}/payouts`
          }
          className={`${classes.navigationLink} ${classes.hideOnMobile}`}
        >
          Payouts
        </Link>
      )}
      <AccountButton />
    </nav>
  );
};
